import gql from 'graphql-tag'

export const CompanyRelatedPermissions = gql`
  fragment CompanyRelatedPermissions on Permission {
    id
    companyAdministration
    companyUserManagement
    templateManagement
    otherCompaniesManagement
    canViewSubscriptionStatus
    configurationChanges
    configurationUpload
    deviceControl
    expertMode
    operationalHistory
    restrictedCustomerData
    fullCustomerData
    contactRead
    contactWrite
    locationRead
    locationReadApproximate
    locationWrite
    userManagement
    serviceSequences
    newProductManagement
    baseProductManagement
    tagManagement
  }
`
